export class PersistentVolumeClaimProperties {
    'providerResourceId';
    'path';
    'availabilityZone';
    'volumeSettings';
    'fsType';
    'pvName';
    'pvcName';
    'accessModes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        },
        {
            "name": "fsType",
            "baseName": "fsType",
            "type": "string",
            "format": ""
        },
        {
            "name": "pvName",
            "baseName": "pvName",
            "type": "string",
            "format": ""
        },
        {
            "name": "pvcName",
            "baseName": "pvcName",
            "type": "string",
            "format": ""
        },
        {
            "name": "accessModes",
            "baseName": "accessModes",
            "type": "Array<KubernetesAccessMode>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PersistentVolumeClaimProperties.attributeTypeMap;
    }
    constructor() {
    }
}
